import { motion } from "framer-motion";

const WORDS = ["Educate", "Empower", "Elevate"];

export function BrandMarquee({ dark = false }) {
  return (
    <section
      className={`relative overflow-hidden py-16 md:py-24 ${dark ? "brand-ink" : "bg-secondary"}`}
      data-testid="brand-marquee"
    >
      {/* soft gold hairlines */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.5 }}
        variants={{ show: { transition: { staggerChildren: 0.16 } } }}
        className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-5 gap-y-4 px-5 md:flex-nowrap md:gap-x-9"
      >
        {WORDS.map((w, i) => (
          <div key={w} className="flex items-center gap-5 md:gap-9">
            <motion.span
              variants={{
                hidden: { opacity: 0, y: 24, filter: "blur(6px)" },
                show: { opacity: 1, y: 0, filter: "blur(0px)" },
              }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="gold-shimmer whitespace-nowrap font-heading text-3xl font-semibold uppercase leading-none tracking-[0.2em] sm:text-4xl md:text-5xl"
            >
              {w}
            </motion.span>
            {i < WORDS.length - 1 && (
              <motion.span
                variants={{
                  hidden: { opacity: 0, scale: 0 },
                  show: { opacity: 1, scale: 1 },
                }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="hidden h-2 w-2 rotate-45 bg-gold md:block md:h-2.5 md:w-2.5"
                aria-hidden="true"
              />
            )}
          </div>
        ))}
      </motion.div>
    </section>
  );
}
